// extracted by mini-css-extract-plugin
export default {"label":"formInput_label__Bbpvs","labelVerb":"formInput_labelVerb__pDOsb","input":"formInput_input__hSSYO","inputVerb":"formInput_inputVerb__r-Br8"};